export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10744.72eea553.jpg";